import { Tab, Tabs, tabsClasses, useMediaQuery, useTheme } from '@mui/material'
import { paths } from 'app/routes'
import { Link } from 'elements/navigation'
import { useTranslation } from 'react-i18next'

import { Toolbar } from './toolbar'

export const GeneralToolbar = () => {
  const { t } = useTranslation()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <Toolbar
      {...(!isMobile && {
        toolbarChildren: (
          <Tabs
            value={location.pathname}
            sx={{
              height: '100%',
              [`& .${tabsClasses.flexContainer}`]: {
                height: '100%',
              },
            }}
          >
            <Tab
              component={Link}
              label={t('projects.list.projects')}
              value={paths.projects}
              to={paths.projects}
              underline="none"
              sx={{ px: 0, minWidth: 'auto' }}
              disableRipple
            />
          </Tabs>
        ),
      })}
    />
  )
}
